import { FormItem, FormItemProps } from '@billy/design-system'

type DetailItemProps = FormItemProps

export const DetailItem = (props: DetailItemProps) => {
  return <FormItem {...props} />
}
